module.exports = __webpack_public_path__ + "static/Curbix-background-23bd2df596f4beb25cac746448f0f603.jpg";